import { useContext, useCallback, useEffect, useMemo, useState } from "react";
import DOMPurify from "dompurify";
import Layout from "../../Component/layout/main-layout";
import layoutBgImg from "../../Images/layout/sale.jpg";
import { GetDocumentSampleTable } from "../../api/Queries/get";
import { useLocation } from "react-router-dom";
import { Context } from "../../Store/context";
import { useTranslation } from "react-i18next";
import Loading from "../../Component/loader/loader";
import GlobalLayout from "../../Component/layout/global-layout";

const Document = () => {
  const location = useLocation().pathname.split("/")[2];
  const [document, setDocument] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { i18n, t } = useTranslation();
  const { showError } = useContext(Context);

  const getLawContent = useCallback(
    (item) => {
      if (!item) return "";
      const currentLang = i18n.language;
      if (currentLang === "ru") {
        return item.rus_content || item.tm_content || "";
      }
      if (currentLang === "en") {
        return item.eng_content || item.tm_content || "";
      }
      return item.tm_content || "";
    },
    [i18n.language]
  );

  const getLawName = useCallback(
    (item) => {
      if (!item) return "";
      const currentLang = i18n.language;
      if (currentLang === "ru") {
        return item.rus_name || item.tm_name || "";
      }
      if (currentLang === "en") {
        return item.eng_name || item.tm_name || "";
      }
      return item.tm_name || "";
    },
    [i18n.language]
  );

  useEffect(() => {
    const getDocumentSample = async () => {
      if (!location) {
        setDocument(null);
        return;
      }
      setIsLoading(true);
      try {
        const res = await GetDocumentSampleTable(location);
        setDocument(res?.data || null);
      } catch (error) {
        showError(error?.message || "Maglumat ýüklenmedi");
      } finally {
        setIsLoading(false);
      }
    };

    getDocumentSample();
  }, [location, showError]);

  const sanitizedContent = useMemo(() => {
    return DOMPurify.sanitize(getLawContent(document));
  }, [document, getLawContent]);

  return (
    <GlobalLayout
      title={`${t("document_sample")} - ${t("supreme_court")} ${t("turkmenistan")}`}
      keywords="Образцы документов, Resminamalaryň nusgalary, Resminama nusgalary"
    >
      <div className="mb-20">
        <Layout
          title={t("document_sample")}
          page={getLawName(document)}
          layoutBgImg={layoutBgImg}
        />

        <main className="media">
          <div
            className="bg-white mt-8 p-8 w-full
                       dark:bg-dark-box dark:text-dark-text"
          >
            {isLoading ? (
              <Loading />
            ) : sanitizedContent ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizedContent,
                }}
              />
            ) : (
              <p className="text-center">Maglumat tapylmady</p>
            )}
          </div>
        </main>
      </div>
    </GlobalLayout>
  );
};

export default Document;